import storeManager from '../../store/StoreManager';
import shapeType from '../../constants/ShapeConstants';
import uuid from 'uuid';
import { createGroup, ungroup } from '../../actions/CurrentSlideActions';
import selectionManager from '../utils/SelectionManager';
import saveManager from './SaveManager';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';

const groupManager = {
    dispatch: undefined,

    getSelectedShapes() {
        const shapes = storeManager.getState().currentSlide.model.content;
        var i;
        var shape;
        var selection = [];

        for (i=1; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.isSelected == true && !shape.isLocked)
                selection.push(shape);
        }

        return selection;
    },
    getLimitPoints(limitPoints, currentX, currentY) {
        limitPoints.xMin = Math.min(currentX, limitPoints.xMin);
        limitPoints.xMax = Math.max(currentX, limitPoints.xMax);
        limitPoints.yMin = Math.min(currentY, limitPoints.yMin);
        limitPoints.yMax = Math.max(currentY, limitPoints.yMax);
    },
    groupUngroup() {
        var shapes = this.getSelectedShapes();

        if (shapes.length == 1 && shapes[0].type == shapeType.GROUP)
            this.ungroup(shapes[0]);
        else
        if (shapes.length >= 2)
            this.group(shapes);

        setTimeout(this.clearSelection, 400);
    },
    clearSelection() {
        selectionManager.isMultipleSelection = false;
    },
    group(shapes) {
        var i;
        var shape;
        var limitPoints = {xMin: -1, yMin: -1, xMax: -1, yMax: -1};

        for (i=0; i<shapes.length; i++) {
            shape = shapes[i];

            if (shape.type == shapeType.LINE || shape.type == shapeType.CURVE) {
                if (limitPoints.xMin == -1) {
                    limitPoints = {xMin: shape.x1, yMin: shape.y1, xMax: shape.x1, yMax: shape.y1};
                }

                this.getLimitPoints(limitPoints, shape.x1, shape.y1);
                this.getLimitPoints(limitPoints, shape.x2, shape.y2);
            } else {
                if (limitPoints.xMin == -1) {
                    limitPoints = {xMin: shape.x, yMin: shape.y, xMax: shape.x, yMax: shape.y};
                }

                this.getLimitPoints(limitPoints, shape.x, shape.y);
                this.getLimitPoints(limitPoints, shape.x + shape.width, shape.y);
                this.getLimitPoints(limitPoints, shape.x + shape.width, shape.y + shape.height);
                this.getLimitPoints(limitPoints, shape.x, shape.y + shape.height);
            }
        }

        var shapeGroup = {};
        shapeGroup.type = shapeType.GROUP;
        shapeGroup.x = limitPoints.xMin;
        shapeGroup.y = limitPoints.yMin;
        shapeGroup.width = Math.abs(limitPoints.xMax - limitPoints.xMin);
        shapeGroup.height = Math.abs(limitPoints.yMax - limitPoints.yMin);
        shapeGroup.opacity = 1;
        shapeGroup.isSelected = true;
        shapeGroup.isLocked = false;
        shapeGroup.rotation = 0;
        shapeGroup.filter = '';
        shapeGroup.uuid = uuid.v4();

        var groupedShapes = [];

        for (i=0; i<shapes.length; i++) {
            shape = shapes[i];

            var newShape = Object.assign({}, shape);
            newShape.isSelected = false;
            newShape.isGrouped = true;

            if (shape.type == shapeType.LINE || shape.type == shapeType.CURVE) {
                newShape.x1 = newShape.x1 - shapeGroup.x;
                newShape.y1 = newShape.y1 - shapeGroup.y;
                newShape.x2 = newShape.x2 - shapeGroup.x;
                newShape.y2 = newShape.y2 - shapeGroup.y;

                if (shape.type == shapeType.CURVE) {
                    newShape.cx = newShape.cx - shapeGroup.x;
                    newShape.cy = newShape.cy - shapeGroup.y;
                }
            } else {
                newShape.x = newShape.x - shapeGroup.x;
                newShape.y = newShape.y - shapeGroup.y;

                if (shape.type == shapeType.SPEAK_BUBBLE || shape.type == shapeType.COMPLEX_SPEAK_BUBBLE || shape.type == shapeType.SCREAM_BUBBLE || shape.type == shapeType.THOUGHT_BUBBLE) {
                    newShape.cx = newShape.cx - shapeGroup.x;
                    newShape.cy = newShape.cy - shapeGroup.y;

                    if (newShape.cx1) {
                        newShape.cx1 = newShape.cx1 - shapeGroup.x;
                        newShape.cy1 = newShape.cy1 - shapeGroup.y;
                    }

                    if (newShape.cx2) {
                        newShape.cx2 = newShape.cx2 - shapeGroup.x;
                        newShape.cy2 = newShape.cy2 - shapeGroup.y;
                    }

                    if (newShape.cx3) {
                        newShape.cx3 = newShape.cx3 - shapeGroup.x;
                        newShape.cy3 = newShape.cy3 - shapeGroup.y;
                    }

                    if (newShape.cx4) {
                        newShape.cx4 = newShape.cx4 - shapeGroup.x;
                        newShape.cy4 = newShape.cy4 - shapeGroup.y;
                    }

                    if (newShape.cx5) {
                        newShape.cx5 = newShape.cx5 - shapeGroup.x;
                        newShape.cy5 = newShape.cy5 - shapeGroup.y;
                    }
                }

                //if (shape.type == shapeType.FREEHAND) {
                //    var points = newShape.pathPoints;
                //    var j;
                //
                //    for (j=0; j<points.length; j++) {
                //        points[j].x = points[j].x - shapeGroup.x;
                //        points[j].y = points[j].y - shapeGroup.y;
                //    }
                //}
            }

            groupedShapes.push(newShape);
        }

        shapeGroup.shapes = groupedShapes;

        this.dispatch(createGroup(shapeGroup));
        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
    },
    ungroup(shapeGroup) {
        var i;
        var shapes = shapeGroup.shapes;
        var shape;
        var newShapes = [];
        var ocx = shapeGroup.x + shapeGroup.width / 2;
        var ocy = shapeGroup.y + shapeGroup.height / 2;
        var rotatedPoint;

        for (i=0; i<shapes.length; i++) {
            shape = shapes[i];

            var newShape = Object.assign({}, shape);
            newShape.isSelected = true;
            newShape.isGrouped = false;

            if (newShape.type == shapeType.LINE || newShape.type == shapeType.CURVE) {
                newShape.x1 = shapeGroup.x + newShape.x1;
                newShape.y1 = shapeGroup.y + newShape.y1;
                newShape.x2 = shapeGroup.x + newShape.x2;
                newShape.y2 = shapeGroup.y + newShape.y2;

                if (newShape.type == shapeType.CURVE) {
                    newShape.cx = shapeGroup.x + newShape.cx;
                    newShape.cy = shapeGroup.y + newShape.cy;
                }

                if (shapeGroup.rotation > 0) {
                    rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, newShape.x1, newShape.y1, ocx, ocy);
                    newShape.x1 = rotatedPoint.x;
                    newShape.y1 = rotatedPoint.y;

                    rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, newShape.x2, newShape.y2, ocx, ocy);
                    newShape.x2 = rotatedPoint.x;
                    newShape.y2 = rotatedPoint.y;

                    if (newShape.type == shapeType.CURVE) {
                        rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, newShape.cx, newShape.cy, ocx, ocy);
                        newShape.cx = rotatedPoint.x;
                        newShape.cy = rotatedPoint.y;
                    }
                }
            } else {
                newShape.x = shapeGroup.x + newShape.x;
                newShape.y = shapeGroup.y + newShape.y;

                var oldX = newShape.x;
                var oldY = newShape.y;

                if (newShape.type == shapeType.SPEAK_BUBBLE || newShape.type == shapeType.COMPLEX_SPEAK_BUBBLE || newShape.type == shapeType.SCREAM_BUBBLE || newShape.type == shapeType.THOUGHT_BUBBLE) {
                    newShape.cx = shapeGroup.x + newShape.cx;
                    newShape.cy = shapeGroup.y + newShape.cy;

                    if (newShape.cx1) {
                        newShape.cx1 = shapeGroup.x + newShape.cx1;
                        newShape.cy1 = shapeGroup.y + newShape.cy1;
                    }

                    if (newShape.cx2) {
                        newShape.cx2 = shapeGroup.x + newShape.cx2;
                        newShape.cy2 = shapeGroup.y + newShape.cy2;
                    }

                    if (newShape.cx3) {
                        newShape.cx3 = shapeGroup.x + newShape.cx3;
                        newShape.cy3 = shapeGroup.y + newShape.cy3;
                    }

                    if (newShape.cx4) {
                        newShape.cx4 = shapeGroup.x + newShape.cx4;
                        newShape.cy4 = shapeGroup.y + newShape.cy4;
                    }

                    if (newShape.cx5) {
                        newShape.cx5 = shapeGroup.x + newShape.cx5;
                        newShape.cy5 = shapeGroup.y + newShape.cy5;
                    }
                }

                if (shapeGroup.rotation > 0) {
                    newShape.rotation = newShape.rotation + shapeGroup.rotation;

                    var cx = newShape.x + newShape.width / 2;
                    var cy = newShape.y + newShape.height / 2;
                    rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, cx, cy, ocx, ocy);

                    newShape.x = rotatedPoint.x - newShape.width / 2;
                    newShape.y = rotatedPoint.y - newShape.height / 2;

                    if (newShape.type == shapeType.SPEAK_BUBBLE || newShape.type == shapeType.COMPLEX_SPEAK_BUBBLE || newShape.type == shapeType.SCREAM_BUBBLE || newShape.type == shapeType.THOUGHT_BUBBLE) {
                        newShape.rotation = 0;
                        newShape.cx = newShape.cx + (newShape.x - oldX);
                        newShape.cy = newShape.cy + (newShape.y - oldY);

                        if (newShape.cx1) {
                            newShape.cx1 = newShape.cx1 + (newShape.x - oldX);
                            newShape.cy1 = newShape.cy1 + (newShape.y - oldY);
                        }

                        if (newShape.cx2) {
                            newShape.cx2 = newShape.cx2 + (newShape.x - oldX);
                            newShape.cy2 = newShape.cy2 + (newShape.y - oldY);
                        }

                        if (newShape.cx3) {
                            newShape.cx3 = newShape.cx3 + (newShape.x - oldX);
                            newShape.cy3 = newShape.cy3 + (newShape.y - oldY);
                        }

                        if (newShape.cx4) {
                            newShape.cx4 = newShape.cx4 + (newShape.x - oldX);
                            newShape.cy4 = newShape.cy4 + (newShape.y - oldY);
                        }

                        if (newShape.cx5) {
                            newShape.cx5 = newShape.cx5 + (newShape.x - oldX);
                            newShape.cy5 = newShape.cy5 + (newShape.y - oldY);
                        }
                    }

                    if (newShape.type == shapeType.TEXTBOX || newShape.type == shapeType.TEXTBOXSIMPLE)
                        newShape.rotation = 0;
                }
            }

            newShapes.push(newShape);
        }

        this.dispatch(ungroup(shapeGroup, newShapes));
        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
    },
    rotatePointAroundAnotherPoint(rotAng, x, y, ox, oy) {
        var nx;
        var ny;
        var sinVal;
        var cosVal;

        rotAng = rotAng * (Math.PI / 180);
        sinVal = Math.sin(rotAng);
        cosVal = Math.cos(rotAng);

        nx = (x - ox)* cosVal - (y - oy) * sinVal;
        ny = (y - oy) * cosVal + (x - ox) * sinVal;

        return {x: nx + ox, y: ny + oy};
    }
};

export default groupManager;



/** WEBPACK FOOTER **
 ** ./src/components/utils/GroupManager.js
 **/